import React, { useState } from 'react';
import { Label } from './Label';
import { FormField } from './FormField';
import { Input } from './Input';
import { validateEmail } from '../../store/registration/actions/validateEmail';

type EmailFormFieldProps = {
  required: boolean;
  onChangeValue: (value: string) => void;
  onChangeValid?: (valid: boolean) => void;
}

export const EmailFormField = (props: EmailFormFieldProps) => {
  const [className, setClassName] = useState<string>('');

  const handleValueChange = (value: string) => {
    const isValid = (!props.required && value.length === 0) || validateEmail(value);

    props.onChangeValue(isValid ? value : '');

    if (props.onChangeValid) {
      props.onChangeValid(isValid);
    }

    // Change input class
    setClassName(!isValid ? 'invalid' : '');
  };

  return <FormField>
    <Label required={props.required}>E-mail:</Label>
    <Input onChange={e => handleValueChange(e.target.value)}
           className={className}
           type='email'
           name='email' />
  </FormField>;
};
